
import { Drawer, Button, Space } from 'antd';
import MusicPlayer from "@/components/MusicPlayer";
import PubSub from 'pubsub-js';
import { useState,useEffect } from 'react';

export default function DrawerAntd(props) {
    const [MusicInfo, setMusicInfo] = useState({})  // 当前播放器所需的播放属性
    useEffect(() => {
        const subscription = PubSub.subscribe('playerInfo', (_, MusicInfo) => {
            // console.log('抽屉组件接收到的信息', 'playerInfo', MusicInfo);
            const {url, playerObject:{filename,format,size}} = MusicInfo 
            setMusicInfo({src:url, size:size, format:format, header:filename+'.'+format,MusicInfo:MusicInfo});  // 将解构出的信息与播放器所需的属性一一对应
        });

        return () => {
            PubSub.unsubscribe(subscription); // 在组件卸载时取消订阅
        };
    }, []); // 只在组件挂载和卸载时执行

    const { onClose } = props
    return (
        <Drawer
            title="菜单"
            placement={'bottom'}
            width={500}
            extra={  // 额外的
                <Space>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={onClose}>
                        OK
                    </Button>
                </Space>
            }
            {...props}
        >
            <MusicPlayer {...MusicInfo} />
        </Drawer>
    )
}
